import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from 'lang'
import IconContent from 'assets/images/icons/check_circle.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import ModalFooter from '@/modules/base/components/modal/footer/modal-footer'
import ButtonIconSquare from '@/modules/base/components/buttons/icon-square/button-icon-square'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    background: theme.white,
    width: 800,
    [theme.devices.mobile]: {
      width: '100%',
      padding: '0 20px',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.xxlarge,
    textAlign: 'center',
    paddingBottom: 16,
  },
  subtitle: {
    color: theme.black,
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 20,
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20,
    paddingBottom: 0,
  },
}))

const SuccessView = (props) => {
  const { onFinish, hideFooter = false } = props
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <SVGIcon svg={IconContent} height='24px' width='24px' fill='#89c958' />
      </div>
      <div className={classes.content}>
        <div className={classes.title}>{lang.upgradeSubscriptionSuccessTitle}</div>
        <span className={classes.subtitle}>{lang.upgradeSubscriptionSuccessSubtitle}</span>
      </div>
      {!hideFooter && <ModalFooter customClass={classes.footer}>
        <ButtonIconSquare label={lang.upgradeSubscriptionSuccessButton} customClass={classes.button} onClick={onFinish} />
      </ModalFooter>}
    </div>
  )
}

export default SuccessView
